<template>
  <div class="cookie-consent-wrapper">
    <div v-if="showCookieConsent && !showDetails" class="cookie-consent-banner">
      <div class="cookie-banner-content">
        <div class="cookie-text">
          <p>{{ $t('CookieConsentMessage') }}</p>
        </div>

        <div class="cookie-actions">
          <div class="action-buttons">
            <b-button
              variant="primary"
              size="sm"
              @click="acceptAll"
              class="accept-btn"
            >
              {{ $t('CookieAcceptAll') }}
            </b-button>
            <b-button
              variant="primary"
              size="sm"
              @click="toggleDetails"
              class="details-btn"
            >
              {{
                showDetails ? $t('CookieHideDetails') : $t('CookieShowDetails')
              }}
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showCookieConsent && showDetails" class="cookie-consent-overlay">
      <div v-if="showManagePreferences" class="cookie-consent-popup">
        <button class="close-btn" @click="toggleDetails" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="cookie-popup-content">
          <div class="popup-header">
            <h4>{{ $t('CookieManagePreferences') }}</h4>
            <p>{{ $t('CookieInformationBody') }}</p>
          </div>
          <div class="cookie-preferences">
            <div class="cookie-category">
              <div class="cookie-category-header">
                <h5>{{ $t('CookieEssential') }}</h5>
                <div class="cookie-toggle">
                  <span class="always-active">{{
                    $t('CookieAlwaysActive')
                  }}</span>
                </div>
              </div>
              <p>{{ $t('CookieEssentialDesc') }}</p>
            </div>

            <div class="cookie-category">
              <div class="cookie-category-header">
                <h5>{{ $t('CookieAnalytics') }}</h5>
                <div class="cookie-toggle">
                  <b-form-checkbox v-model="analyticsCookies" switch size="lg">
                  </b-form-checkbox>
                </div>
              </div>
              <p>{{ $t('CookieAnalyticsDesc') }}</p>
            </div>

            <div class="cookie-category">
              <div class="cookie-category-header">
                <h5>{{ $t('CookieMarketing') }}</h5>
                <div class="cookie-toggle">
                  <b-form-checkbox v-model="marketingCookies" switch size="lg">
                  </b-form-checkbox>
                </div>
              </div>
              <p>{{ $t('CookieMarketingDesc') }}</p>
            </div>
          </div>

          <div>
            <b-button
              variant="outline-secondary"
              @click="toggleCookiePolicy"
              class="cookie-policy-btn"
            >
              {{ $t('showPrivacy') }}
            </b-button>
            <b-button
              variant="primary"
              @click="savePreferences"
              class="save-preferences-btn"
            >
              {{ $t('CookieSavePreferences') }}
            </b-button>
          </div>
        </div>
      </div>

      <div
        v-if="!showManagePreferences && !showCookiePolicy"
        class="cookie-consent-popup"
      >
        <button class="close-btn" @click="toggleDetails" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="cookie-popup-content">
          <div class="popup-header">
            <h4>{{ $t('CookieInformationHeader') }}</h4>
            <p>{{ $t('CookieInformationBody') }}</p>
            <b-button
              variant="primary"
              size="sm"
              @click="toggleCookiePolicy"
              class="cookie-policy-btn"
            >
              {{ $t('showPrivacy') }}
            </b-button>
          </div>
        </div>
      </div>
      <div v-if="showCookiePolicy" class="cookie-policy-content">
        <button
          class="close-btn"
          @click="toggleCookiePolicy"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="cookie-policy-header">
          <h4>
            {{ $t('PrivacyHeader') }}
          </h4>
          <p>{{ $t('effectiveDate') }}</p>
          <p>{{ $t('updateDate') }}</p>
          <p>{{ $t('privacyPolicy') }}</p>
          <p>{{ $t('informationWeCollect') }}</p>
          <ul class="privacy-list">
            <li v-html="$t('informationYouProvideToUs')"></li>
            <li v-html="$t('informationWeCollectAutomatically')"></li>
            <li v-html="$t('HowWeUseYourInformation')"></li>
            <li v-html="$t('LegalBasis')"></li>
            <li v-html="$t('SharingInfo')"></li>
            <li v-html="$t('YourRightsA')"></li>
            <li v-html="$t('YourRightsB')"></li>
            <li v-html="$t('CookiesAndTrackingTechnologies')"></li>
            <li v-html="$t('DataRetention')"></li>
            <li v-html="$t('DataSecurity')"></li>
            <li v-html="$t('InternationalDataTransfers')"></li>
            <li v-html="$t('ChildrensPrivacy')"></li>
            <li v-html="$t('ChangesToThisPolicy')"></li>
            <li v-html="$t('ContactUs')"></li>
          </ul>

          <b-button
            variant="primary"
            size="sm"
            @click="managePreferences"
            class="manage-btn"
          >
            {{ $t('CookieManage') }}
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieConsent',
  data() {
    return {
      showCookieConsent: false,
      showDetails: false,
      showManagePreferences: false,
      showCookiePolicy: false,

      essentialCookies: true,
      analyticsCookies: false,
      marketingCookies: false,

      cookieConfig: {
        consent: 'cookie-consent',
        preferences: 'cookie-preferences',
        analytics: ['_ga', '_gid', '_gat_gtag_UA_', '_gtag_GA_'],
        marketing: ['_fbp', '_fbc', 'fr']
      }
    }
  },

  mounted() {
    console.log('CookieConsent component mounted')
    this.checkCookieConsent()
    this.loadSavedPreferences()
  },

  methods: {
    checkCookieConsent() {
      console.log('cookieconsent called')
      const consent = this.$cookies.get(this.cookieConfig.consent)
      console.log('Cookie consent status:', consent)
      if (!consent) {
        setTimeout(() => {
          this.showCookieConsent = true
        }, 1000)
      } else {
        this.loadSavedPreferences()
        this.applyCookieSettings()
      }
    },

    loadSavedPreferences() {
      const preferences = this.$cookies.get(this.cookieConfig.preferences)
      if (preferences) {
        try {
          const prefs = JSON.parse(preferences)
          this.analyticsCookies = prefs.analytics || false
          this.marketingCookies = prefs.marketing || false
        } catch (e) {
          console.warn('Failed to load cookie preferences:', e)
        }
      }
    },

    managePreferences() {
      this.showManagePreferences = true
      this.showDetails = true
      this.showCookiePolicy = false
    },

    toggleDetails() {
      this.showDetails = !this.showDetails
      this.showManagePreferences = false
      this.showCookiePolicy = false
    },

    toggleCookiePolicy() {
      this.showCookiePolicy = !this.showCookiePolicy
      this.showManagePreferences = false
    },

    acceptAll() {
      this.analyticsCookies = true
      this.marketingCookies = true
      this.saveConsentAndClose()
    },

    savePreferences() {
      this.saveConsentAndClose()
    },

    saveConsentAndClose() {
      this.$cookies.set(
        this.cookieConfig.consent,
        'given',
        '365d',
        null,
        null,
        true
      )

      const preferences = {
        essential: true,
        analytics: this.analyticsCookies,
        marketing: this.marketingCookies,
        timestamp: new Date().toISOString()
      }
      this.$cookies.set(
        this.cookieConfig.preferences,
        JSON.stringify(preferences),
        '365d',
        null,
        null,
        true
      )
      this.applyCookieSettings()
      this.showCookieConsent = false
      this.$emit('cookies-updated', preferences)
      this.showConsentConfirmation()
    },

    applyCookieSettings() {
      if (this.analyticsCookies) {
        this.enableAnalytics()
      } else {
        this.disableAnalytics()
      }

      if (this.marketingCookies) {
        this.enableMarketing()
      } else {
        this.disableMarketing()
      }
    },

    enableAnalytics() {
      console.log('Analytics cookies enabled')
      if (window.gtag) {
        window.gtag('consent', 'update', {
          analytics_storage: 'granted'
        })
      }
    },

    disableAnalytics() {
      console.log('Analytics cookies disabled')

      this.cookieConfig.analytics.forEach(cookieName => {
        this.$cookies.remove(cookieName)
        this.$cookies.remove(cookieName, '/')
        this.$cookies.remove(cookieName, '/', window.location.hostname)
      })

      if (window.gtag) {
        window.gtag('consent', 'update', {
          analytics_storage: 'denied'
        })
      }
    },

    enableMarketing() {
      console.log('Marketing cookies enabled')
      if (window.gtag) {
        window.gtag('consent', 'update', {
          ad_storage: 'granted',
          ad_user_data: 'granted',
          ad_personalization: 'granted'
        })
      }
    },

    disableMarketing() {
      console.log('Marketing cookies disabled')

      this.cookieConfig.marketing.forEach(cookieName => {
        this.$cookies.remove(cookieName)
        this.$cookies.remove(cookieName, '/')
        this.$cookies.remove(cookieName, '/', window.location.hostname)
      })

      if (window.gtag) {
        window.gtag('consent', 'update', {
          ad_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied'
        })
      }
    },

    showConsentConfirmation() {
      this.$bvToast.toast(this.$t('CookiePreferencesSaved'), {
        title: this.$t('CookieConsentTitle'),
        variant: 'success',
        autoHideDelay: 3000,
        toaster: 'b-toaster-bottom-right'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.cookie-consent-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border-top: 1px solid #e0e0e0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  animation: slideUpFromBottom 0.3s ease-out;
}

.cookie-banner-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 2rem;
  gap: 2rem;
}

.cookie-category-header {
  font: bold;
}
.cookie-text {
  flex: 1;

  h4 {
    margin: 0 0 0.5rem 0;
    color: #333;
    font-weight: 600;
    font-size: 1.1rem;
  }

  p {
    margin: 0;
    color: #666;
    line-height: 1.4;
    font-size: 0.9rem;
  }
}

.cookie-toggle {
  color: rgb(105, 61, 139);
}

.always-active {
  color: black;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #999;
  padding: 0;
  margin-left: 1rem;

  &:hover {
    color: #333;
  }
}

.cookie-category {
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }

  h5 {
    font-size: 0.9rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 0.25rem;
  }

  p {
    font-size: 0.8rem;
    color: #666;
    margin-bottom: 0.5rem;
    line-height: 1.3;
  }
}

.cookie-actions {
  flex-shrink: 0;
}

.action-buttons {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-wrap: wrap;
}

.details-btn {
  padding: 0.375rem 0.75rem;
  text-decoration: underline;
  font-size: 0.85rem;
  white-space: nowrap;
  min-width: 150px;
  border-color: rgb(105, 61, 139);
  color: rgb(105, 61, 139);
  background-color: transparent;
}

.manage-btn {
  padding: 0.375rem 0.75rem;
  min-width: 150px;
  font-weight: 500;
  white-space: nowrap;
  color: white;
  background-color: rgb(105, 61, 139);
  border-color: rgb(105, 61, 139);
}
.accept-btn {
  padding: 0.375rem 0.75rem;
  min-width: 150px;
  font-weight: 500;
  white-space: nowrap;
  color: white;
  background-color: rgb(105, 61, 139);
  border-color: rgb(105, 61, 139);
}

.save-preferences-btn {
  padding: 0.375rem 0.75rem;
  text-decoration: underline;
  font-size: 0.85rem;
  white-space: nowrap;
  min-width: 150px;
  border-color: rgb(105, 61, 139);
  color: rgb(105, 61, 139);
  background-color: transparent;
}

.cookie-policy-btn {
  padding: 0.375rem 0.75rem;
  min-width: 150px;
  font-weight: 500;
  white-space: nowrap;
  color: white;
  background-color: rgb(105, 61, 139);
  border-color: rgb(105, 61, 139);
}

.cookie-consent-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
  animation: fadeIn 0.3s ease-out;
}

.cookie-preferences {
  display: flex;
  flex-direction: column;
  padding-left: 1rem;
}

.cookie-consent-popup,
.cookie-policy-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  animation: slideUp 0.3s ease-out;
}

.cookie-popup-content,
.cookie-policy-header {
  padding: 2rem;
}

.popup-header {
  h4 {
    margin: 0 0 1rem 0;
    color: #333;
    font-weight: 600;
    font-size: 1.25rem;
  }

  p {
    margin-bottom: 1.5rem;
    color: #666;
    line-height: 1.6;
  }
}

.privacy-list {
  padding-left: 1.5rem;
  margin: 1rem 0;

  li {
    margin-bottom: 1rem;
    line-height: 1.5;
    color: #666;
    // Nested lists within privacy items
    ul {
      margin-top: 0.5rem;
      margin-bottom: 0.5rem;
      padding-left: 1.2rem;
      li {
        margin-bottom: 0.3rem;
        font-size: 0.9rem;
        list-style-type: disc;
      }
    }
    strong {
      color: #333;
      font-weight: 600;
    }
  }
}

// Animations
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// Animation
@keyframes slideUpFromBottom {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

// Mobile responsive
@media (max-width: 768px) {
  .cookie-banner-content {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }

  .cookie-text {
    h4 {
      font-size: 1rem;
    }

    p {
      font-size: 0.85rem;
    }
  }

  .close-btn {
    position: absolute;
    top: 1rem;
    right: 1rem;
    margin: 0;
  }

  .action-buttons {
    width: 100%;
    justify-content: space-between;

    .btn {
      flex: 1;
      min-width: 0;
      font-size: 0.85rem;
    }
  }

  .details-btn {
    width: 100%;
    text-align: center;
    margin-bottom: 0.5rem;
  }
}

@media (max-width: 480px) {
  .action-buttons {
    flex-direction: column;
    gap: 0.5rem;

    .btn {
      width: 100%;
    }
  }

  .cookie-banner-content {
    padding: 1rem 1rem 1rem 1rem;
    padding-right: 3rem; // Space for close button
  }
}
</style>
